import { render } from "./DisclaimerPage.vue?vue&type=template&id=4cfca697&scoped=true"
import script from "./DisclaimerPage.vue?vue&type=script&lang=js"
export * from "./DisclaimerPage.vue?vue&type=script&lang=js"

import "./DisclaimerPage.vue?vue&type=style&index=0&id=4cfca697&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cfca697"]])

export default __exports__